var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sidebar", attrs: { id: "sidebar" } }, [
      _c("div", { staticClass: "sidebar-inner v-slimscroll" }, [
        _c("div", { staticClass: "sidebar-menu" }, [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/index" } }, [
                  _c("i", { staticClass: "la la-home" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Back to Home")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: { alt: "", src: require("../../assets/user.jpg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [_vm._v("#General")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: { alt: "", src: require("../../assets/user.jpg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("#Video Responsive Survey")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: { alt: "", src: require("../../assets/user.jpg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [_vm._v("#500rs")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: { alt: "", src: require("../../assets/user.jpg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("#warehouse")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        alt: "",
                        src: require("../../assets/profiles/avatar-02.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "status online" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("John Doe")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge badge-pill bg-danger" }, [
                    _vm._v("1")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        alt: "",
                        src: require("../../assets/profiles/avatar-09.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "status offline" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("Richard Miles")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge badge-pill bg-danger" }, [
                    _vm._v("7")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        alt: "",
                        src: require("../../assets/profiles/avatar-10.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "status away" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("John Smith")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "active" },
              [
                _c("router-link", { attrs: { to: "/chat" } }, [
                  _c("span", { staticClass: "chat-avatar-sm user-img" }, [
                    _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        alt: "",
                        src: require("../../assets/profiles/avatar-05.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "status online" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "chat-user" }, [
                    _vm._v("Mike Litorus")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge badge-pill bg-danger" }, [
                    _vm._v("2")
                  ])
                ])
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "menu-title" }, [
      _c("span", [_vm._v("Chat Groups")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "#",
            "data-toggle": "modal",
            "data-target": "#add_group"
          }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "menu-title" }, [
      _vm._v("\n            Direct Chats\n            "),
      _c(
        "a",
        {
          attrs: {
            href: "#",
            "data-toggle": "modal",
            "data-target": "#add_chat_user"
          }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f037ea4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f037ea4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/SidebarEmployee.vue
// module id = null
// module chunks = 